module.exports = __webpack_public_path__ + "img/Z61_17.d9a67dc7.jpg";